import styled from 'styled-components';

export const CreateEmployeeWrapper = styled.div`
  .ant-form-item {
    width: 288px;
  }
`;

export const ComponentWrapper = styled.div`
  margin: 20px 0;
  & > div:first-child {
    margin-bottom: 16px;
  }

  & > div:last-child {
    display: flex;
    & > div {
      margin-right: 48px;
    }
  }
`;

export const DeleteContainer = styled.div<{ isIcon: boolean }>`
  display: flex;

  ${({ isIcon }) =>
    isIcon &&
    `
    & > div:last-child {
        cursor: pointer;
        margin-left: 18px;
        margin-top: 7px;
    }
  `}
`;

export const FormListWrapper = styled.div<{ isIcon: boolean; isSalary?: boolean }>`
  display: flex;
  flex-direction: column;

  & > div:last-child {
    margin-top: ${({ isSalary }) => (isSalary ? 0 : '10px')};
    margin-right: ${({ isIcon }) => (isIcon ? '40px' : 0)};
    align-self: flex-end;

    .ant-btn {
      padding: 0;
    }
  }

  ${({ isSalary }) =>
    !isSalary &&
    `
    & > div:first-child { 
      margin-bottom: 16px;
    }  
    `}
`;
